module.exports = __webpack_public_path__ + "img/pro_banner.d93cbbbb.png";